import { render, staticRenderFns } from "./document-info.vue?vue&type=template&id=47ca8ffc&scoped=true&"
import script from "./document-info.vue?vue&type=script&lang=js&"
export * from "./document-info.vue?vue&type=script&lang=js&"
import style0 from "./document-info.vue?vue&type=style&index=0&id=47ca8ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca8ffc",
  null
  
)

export default component.exports